import * as React from "react";
import BaseLayout from "../../components/BaseLayout";
import AllInstallations from "../../features/AllInstallations";

function AllInstallationsPage() {
  return (
    <BaseLayout paddingTop>
      <AllInstallations />
    </BaseLayout>
  );
}

export default AllInstallationsPage;
